import i18n from 'i18next';

export const navigationTypeOptions = () => [
	{
		value: '',
		title: i18n.t('scorm_nav_type_default'),
	},
	{
		value: 'lockstep',
		title: i18n.t('scorm_nav_type_lockstep'),
	},
	{
		value: 'examaftercontent',
		title: i18n.t('scorm_nav_type_exam_after_content'),
	},
	{
		value: 'onlyonce',
		title: i18n.t('scorm_nav_type_only_once'),
	},
];

export const openContentInOptions = [
	{
		value: 'inline',
		bool: false,
	},
	{
		value: 'popup',
		bool: true,
	},
];

export const getCreditOptions = [
	{
		value: 'credit',
		bool: true,
	},
	{
		value: 'no-credit',
		bool: false,
	},
];

export const masteryScoreOptions = () => [
	{
		value: '',
		title: i18n.t('scorm_mastery_score_default'),
	},
	{
		value: 'always',
		title: i18n.t('scorm_mastery_score_always'),
	},
	{
		value: 'after_completion',
		title: i18n.t('scorm_mastery_score_after_completion'),
	},
];

export const scoreRollupActionOptions = () => [
	{
		value: '',
		title: i18n.t('scorm_score_rollup_default'),
	},
	{
		value: 'first',
		title: i18n.t('scorm_score_rollup_first'),
	},
	{
		value: 'last',
		title: i18n.t('scorm_score_rollup_last'),
	},
];

export const statusRollupActionOptions = () => [
	{
		value: '',
		title: i18n.t('scorm_status_rollup_default'),
	},
	{
		value: 'first',
		title: i18n.t('scorm_status_rollup_first'),
	},
	{
		value: 'last',
		title: i18n.t('scorm_status_rollup_last'),
	},
];
